import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styles from './Navbar.module.css';
import logo from '../../assets/images/mobdramalogo.jpg'; // Ensure the path to the logo image is correct

const Navbar: React.FC = () => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    const closeMenu = () => {
        setIsOpen(false);
    };

    return (
        <nav className={styles.navbar}>
            <Link to="/" className={styles.logoLink} onClick={closeMenu}>
                <img src={logo} alt="Mob Drama Logo" className={styles.logo} />
            </Link>
            <div className={styles.menuIcon} onClick={toggleMenu}>
                <div className={isOpen ? `${styles.bar} ${styles.active}` : styles.bar}></div>
                <div className={isOpen ? `${styles.bar} ${styles.active}` : styles.bar}></div>
                <div className={isOpen ? `${styles.bar} ${styles.active}` : styles.bar}></div>
            </div>
            <ul className={isOpen ? `${styles.navLinks} ${styles.active}` : styles.navLinks}>
                <li><Link to="/" onClick={closeMenu}>Home</Link></li>
                <li><Link to="/about" onClick={closeMenu}>About</Link></li>
                <li><Link to="/contact" onClick={closeMenu}>Contact</Link></li>
                <li><Link to="/gallery" onClick={closeMenu}>Gallery</Link></li>
                <li><Link to="/music" onClick={closeMenu}>Music</Link></li>
            </ul>
        </nav>
    );
};

export default Navbar;
